/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 9/3/2022
 */

import {CompletionStatus} from "@shared/Workflow/CompletionStatus";
import {WorkflowDocumentType} from "@shared/Workflow/WorkflowDocumentType";

import BaseObject from "@shared/BaseObject";
import {DbObjectType, toQwoachFileType} from "@shared/Workflow/DbObjectType";
import dayjs from "dayjs";
import QwoachFileRef from "@shared/Drive/QwoachFileRef.js";

export default class WorkflowDocRefItem extends BaseObject {

	documentId: string = null
	documentResponseId: string = null
	documentDownloadUrl: string = null
	documentTitle: string = null
	completionStatus: CompletionStatus = null
	documentType: WorkflowDocumentType = null
	objectType: DbObjectType = null
	documentCompletedTs: number = null
	documentSentTs: number = null

	followupsSentCount: number = 0

	isEmailed: boolean = false

	score: number = null
	scoreTitle: string = null

	_isLocked: boolean = null
	_lockReason: string = null
	_tooltipText: string = null
	_subTitle: string = null
	_canResend: boolean = null


	constructor(documentId: string, documentTitle: string, documentType = null, objectType = null) {
		super();
		this.documentId = documentId;
		this.documentTitle = documentTitle;
		this.documentType = documentType
		this.objectType = objectType
	}

	setRequiresFollowup(){
		this.completionStatus = CompletionStatus.REQUIRES_FOLLOWUP
	}

	setNeedsRetakeSafetyCare(){
		this.completionStatus = CompletionStatus.NEEDS_RETAKE_SAFETY_CARE
	}

	isRequiresFollowup(){
		return this.completionStatus === CompletionStatus.REQUIRES_FOLLOWUP
	}
	isCompleted(){
		return this.completionStatus === CompletionStatus.COMPLETED || this.isWaitingOther()
	}
	setCompleted(){
		return this.completionStatus = CompletionStatus.COMPLETED
	}

	canResend(){
		return this._canResend
	}
// 	isCompleted(){
// 		return this.completionStatus === CompletionStatus.COMPLETED
// 	}
// || this.isCompletedPending()
	isWaitingOther(){
		return this.completionStatus === CompletionStatus.WAITING_OTHER
	}
	setWaitingOther(){
		this.completionStatus = CompletionStatus.WAITING_OTHER
	}

	isPendingSignature(){
		return this.completionStatus === CompletionStatus.WAITING_FOR_SIGNATURE
	}

	isForm(){
		return this.objectType === DbObjectType.FORM_ITEM
	}

	isLegalDocument(){
		return this.objectType === DbObjectType.LEGAL_DOC
	}

	isSafetyRiskAssessment(){
		return this.documentType === WorkflowDocumentType.SAFETY_RISK_ASSESSMENT
	}

	completedOnFormatted(){
		if(this.documentCompletedTs > 0){
			return dayjs(this.documentCompletedTs).format("MMM DD, YYYY")
		}
		return "not completed"
	}

	setIsLocked(isLocked, lockReason){
		this._isLocked = isLocked
		this._lockReason = lockReason
	}

	asQwoachFileRef(){
		return new QwoachFileRef(this.documentId, this.documentTitle, toQwoachFileType(this.objectType))
	}
}
